import React, { useState } from 'react';
import { Bot } from 'lucide-react';
import styles from './TaskingBotAvatarPortal.module.css';

const PRIMARY_AVATAR = '/taskingbot.png';
const FALLBACK_AVATAR = 'https://robohash.org/taskingbot-king.png?set=set1&size=256x256';

type TaskingBotAvatarPortalSize = 'sm' | 'md' | 'lg';

interface TaskingBotAvatarPortalProps {
  size?: TaskingBotAvatarPortalSize;
  className?: string;
  alt?: string;
}

const ICON_SIZE_MAP: Record<TaskingBotAvatarPortalSize, number> = {
  sm: 13,
  md: 18,
  lg: 24,
};

export function TaskingBotAvatarPortal({
  size = 'sm',
  className = '',
  alt = 'TaskingBot avatar',
}: TaskingBotAvatarPortalProps) {
  const [src, setSrc] = useState(PRIMARY_AVATAR);
  const [loaded, setLoaded] = useState(false);

  return (
    <span
      className={`${styles.portal} ${styles[size]} ${className}`.trim()}
      role="img"
      aria-label={alt}
    >
      <span className={styles.portalCore} />
      <img
        src={src}
        alt={alt}
        className={`${styles.portalImage} ${loaded ? styles.portalImageVisible : ''}`}
        onLoad={() => setLoaded(true)}
        onError={() => {
          if (src !== FALLBACK_AVATAR) {
            setLoaded(false);
            setSrc(FALLBACK_AVATAR);
          }
        }}
      />
      <span className={styles.portalLowerMask} />
      <span className={styles.portalGlow} />
      <span className={`${styles.portalFallback} ${loaded ? styles.portalFallbackHidden : ''}`}>
        <Bot size={ICON_SIZE_MAP[size]} />
      </span>
    </span>
  );
}
